(function(){
    'use strict';
    angular.module('Services').service('AccountingCaseManagementTableService', AccountingCaseManagementTableService);
    AccountingCaseManagementTableService.$inject = [
        'TableLiteFactory',
        'AccountingService'
    ];

    function AccountingCaseManagementTableService(
        TableLiteFactory,
        AccountingService
    ){
        return function(){
            const tableData = {
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    colMinWidth: '135px'
                },
                headers: [
                    {
                        label: 'Invoice Id',
                        viewName: 'invoiceId',
                        filter: {
                            type: 'text',
                            placeholder: 'Searcin Invoice Id',
                            filterName: 'shipment.invoiceId',
                            onSubmit: function(header){
                                tableActions.sendRequest(tableActions.evaluateFilter(header));
                            }
                        },
                        headerFn: function(){
                            tableActions.sort(this.filterName);
                        }
                    },
                    {
                        label: 'Company',
                        viewName: 'company',
                        filter: {
                            type: 'text',
                            placeholder: 'Search Company',
                            filterName: 'shipment.company.name',
                            onSubmit: function(header){
                                tableActions.sendRequest(tableActions.evaluateFilter(header));
                            }
                        },
                        headerFn: function(){
                            tableActions.sort(this.filterName);
                        }
                    },
                    {
                        label: 'Carrier',
                        viewName: 'carrier',
                        filter: {
                            type: 'text',
                            placeholder: 'Search Carrier',
                            filterName: 'shipment.carrierProfile.carrierId',
                            onSubmit: function(header){
                                tableActions.sendRequest(tableActions.evaluateFilter(header));
                            }
                        },
                        headerFn: function(){
                            tableActions.sort(this.filterName);
                        }
                    },
                    {
                        label: 'Number Of Cases',
                        viewName: 'numberOfCases',
                    },
                    {
                        label: 'Status',
                        viewName: 'status'
                    }
                ],
                data: []
            }

            const tableActions = new TableLiteFactory(tableData, {
                serviceCallback: AccountingService.CaseManagement.getAll,
                callbackFormat: ['success', 'error', 'filter'],
                postRequestCallback: data => {
                    buildTableData(data);
                },
                postRequestErrorCallback: err => {
                    buildTableData(null);
                    console.log(err);
                },
                defaultFilters: {
                    size: 20, 
                    page: 0, 
                    sort: 'id,desc'
                }
            });

            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;

            function buildTableData(data){
                tableActions.initializeTableData(data);
                if(!data) {
                    return null;
                }

                data.content.forEach( row => {
                    row.invoiceId = angular.getObjVal(row.shipment, 'shipment.invoiceId') || 'N/A';
                    row.company = angular.getObjVal(row.shipment, 'company.name') || 'N/A';
                    row.carrier = angular.getObjVal(row.shipment, 'carrierProfile.carrierId') || 'N/A';
                    row.numberOfCases = row.cases.length;
                    row.status = row.resolved ? 'RESOLVED' : 'NOT RESOLVE';
                    row.href= `/accounting/case-details/${row.id}`;

                    if(!row.resolved){
                        row.class = 'bg-error';
                    }

                    tableData.data.push(row);
                });
            }

            this.tableData = tableData;
        }
    }
})()


// WEBPACK FOOTER //
// ./js/services/tables/AccountingCaseManagementTableService.js